import { render, staticRenderFns } from "./buyProperti.vue?vue&type=template&id=62439c9a&"
import script from "./buyProperti.vue?vue&type=script&lang=ts&"
export * from "./buyProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports